import { useEffect, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useNavigate } from 'react-router'
import { Spinner } from '@/components/Spinner'
import { bootstrapSession } from './actions'
import { useSession } from './session'

/** Runs the silent Firebase → WebSession exchange once, and routes a refusal. */
export function SessionBootstrap({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  useEffect(() => {
    let cancelled = false
    void bootstrapSession().then((outcome) => {
      if (!cancelled && outcome && !outcome.ok && outcome.redirect) navigate(outcome.redirect, { replace: true })
    })
    return () => {
      cancelled = true
    }
  }, [navigate])
  return children
}

export function Splash() {
  const { t } = useTranslation()
  return (
    <div className="soc-backdrop grid h-full place-items-center">
      <div className="flex flex-col items-center gap-5">
        <Wordmark size="lg" />
        <Spinner label={t('session.restoring')} />
      </div>
    </div>
  )
}

/** Protected routes: wait for the restore, then require a session. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useSession((s) => s.status)
  const location = useLocation()
  if (status === 'restoring') return <Splash />
  if (status !== 'signedIn') return <Navigate to="/login" replace state={{ from: location }} />
  return children
}

export function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const big = size === 'lg'
  return (
    <div className="flex items-baseline gap-2 select-none" aria-label="MafiaGo">
      <span className={`font-title font-semibold tracking-[0.18em] text-ink uppercase ${big ? 'text-[44px]' : 'text-[20px]'}`}>
        Mafia<span className="text-crimson">Go</span>
      </span>
    </div>
  )
}
